<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Logs"
              bc1="App"
              bc2="Logs"
              bc3="List"
          ></Breadcrumb>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button
                type="button"
                class="btn btn-gradient-danger btn-sm"
                @click="backTo"
            >
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <div class="card">
          <h5 class="card-header">Filters</h5>
          <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
            <div class="col-md-3 col-sm-12 ">
              <date-picker
                  v-model="startDate"
                  :disabledDate="disableFutureDates"
                  valueType="format"
                  :lang="lang"
                  name="toDate"
                  placeholder="choose starting date"
              ></date-picker>
            </div>
            <div class="col-md-3 col-sm-12">
              <date-picker
                  v-model="endDate"
                  :disabledDate="disableFutureDates"
                  valueType="format"
                  :lang="lang"
                  name="fromDate"
                  placeholder="choose ending date"
              ></date-picker>
            </div>
            <div class="col-md-3 col-sm-12">
              <select  class="form-control" v-model="logsType">
                <option value="">Select type</option>
                <option value="external">External Api</option>
                <option value="api">App Api</option>
              </select>
            </div>
            <div class="col-md-3 col-sm-12">
              <input class="form-control" type="text" v-model="search" placeholder="Search..."/>
            </div>
          </div>
          <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
            <div class="col-lg-4 mb-1 col-sm-12">
              <input class="form-control" type="text" v-model="transactionId" placeholder="Search Transaction..."/>
            </div>
            <div class="col-lg-4 mb-1 col-sm-12">
              <select  class="form-control" v-model="code">
                <option value="">Select Code</option>
                <option :value="200">Success</option>
                <option :value="400">Failed</option>
                <option :value="401">Session Timeout</option>
              </select>
            </div>
            <div class="col-lg-4 mb-1 col-sm-12" v-show="!loadingState" >
              <button type="button" class="btn btn-primary"  @click="onSubmitFilters" >Search</button>
              <button type="button" class="ml-1 btn btn-danger " @click="clear" >Clear</button>
            </div>
            <div class="col-lg-4 mb-1 col-sm-12  justify-content-center" v-show="loadingState" >
              <div class="spinner-border text-primary"></div>
            </div>
          </div>

        </div>
        <div class="card">
          <LoadMoreCommonTable
              url="v1/get-merchant-logs"
              :filteredData="filteredData"
              :tableHeaderValues="tableHeaderValues"
              :actions="[]"
              :deleteActions="[]"
              :mutedData="[]"
              :storageKey="storageKey"
              :externalTotalRecord="externalTotalRecord"
              :loadMore="true"
              :showPerPage="true"
              @loadingState="(val)=>{return loadingState = val}"





          />
        </div>
      </div>
    </div>
    <TreeModal :show="showTree" :treeData="treeData" @hide="showTree= false"></TreeModal>
  </div>
  <!-- END: Content-->
</template>

<script>
import TreeModal from "@/pages/dashboard/merchant/logs/Tree";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
export default {
  props: ['propFilters'],
  components: {
    TreeModal,
    DatePicker
  },
  mounted() {
    localStorage.setItem("url", "v1/get-merchant-logs");
    this.checkDataInStore('v1/get-merchant-logs')
    if (
        typeof this.$route.params.update == "undefined" &&
        typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }
  },
  data() {
    return {
      loadingState:false,
      previousRoute:null,
      search: "",
      transactionId: "",
      startDate: null,
      endDate: null,
      code:'',
      logsType:'',
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: false,
      },
      showTree:false,
      treeData:{},
      externalTotalRecord: "",
      storageKey: "merchant-logs",
      accountId: null,
      selectdValet: null,
      filteredData:{userId : this.$route.params.id },
      valetData: [],
      tableHeaderValues: [
        {
          title: 'Id',
          valueKey: 'id',
          html: true,
          alter: function (value) {
            var html = ''
            if (value)
              html = `<span class="text-info" >${value}</span>`


            return html


          },
        },
        {
          title: 'IP Address',
          valueKey: 'ip_address',
          html: true,
          alter: function (value) {
            var html = ''
            if (value)
              html = `<span class="text-primary" >${value}</span>`


            return html


          },
        },
        {
          title: 'Response Code',
          valueKey: 'response_code',
          html: true,
          alter: function (value) {
            var html = ''
            if(value == 200){
              html = ` <span class="badge light badge-light-success">
														${value}
													</span>`
            }else if(value == 400){
              html = ` <span class="badge light badge-light-secondary">
														${value}
													</span>`
            }else{
              html = ` <span class="badge light badge-light-danger">
														${value}
													</span>`
            }

            return html


          }
        },
        {
          title: 'Request Endpoint',
          valueKey: 'request_endpoint',
          html: true,
          alter: function (value) {
            var html = ''
            if (value)
              html = `<span class="text-primary" >${value}</span>`


            return html


          },
        },
        {
          title: 'Request Data',
          valueKey: 'request_data',
          html: true,
          alter: function (value) {
            var html = ''
              html = `<span class="badge badge-sm btn badge-success">View request data</span>`

            return html


          },
          cta: (row) => {
            if(row.request_data){
              this.treeData = row.request_data
            }else{
              this.treeData = {}
            }

            this.showTree = true
          }
        },
        {
          title: 'Response Data',
          valueKey: 'response_data',
          html: true,
          alter: function (value) {
            var html = ''
            html = `<span class="badge badge-sm btn badge-warning">View response data</span>`

            return html


          },
          cta: (row) => {
            if(row.response_data){
              this.treeData = row.response_data
            }else{
              this.treeData = {}
            }

            this.showTree = true
          }
        },
        {
          title: 'Request Headers',
          valueKey: 'request_header',
          html: true,
          alter: function (value) {
            var html = ''
            html = `<span class="badge badge-sm btn badge-info">View request headers</span>`

            return html


          },
          cta: (row) => {
            if(row.request_header){
              this.treeData = row.request_header
            }else{
              this.treeData = {}
            }

            this.showTree = true
          }
        },
        {
          title: 'Other Details',
          valueKey: 'other_info',
          html: true,
          alter: function (value) {
            var html = ''
            html = `<span class="badge badge-sm btn badge-light-primary">View other details</span>`

            return html


          },
          cta: (row) => {
            if(row.other_info){
              this.treeData = row.other_info
            }else{
              this.treeData = {}
            }

            this.showTree = true
          }
        },
        {
          title: 'Request Time',
          valueKey: 'created_at',
          alter: (value) => {
            return this.customFormatDateTime(value)
          }
        },
        {
          title: 'Response Time',
          valueKey: 'updated_at',
          alter: (value) => {
            return this.customFormatDateTime(value)
          }
        },
      ],
      actions: []
    }
  },
  methods: {
    backTo(){
      if(this.previousRoute){
        let propFilters = this.propFilters
        this.$router.push({name:this.previousRoute,params:{propFilters}})
      }else{
        this.$router.back()
      }

    },
    onSubmitFilters() {

      let filterData = {userId : this.$route.params.id}


      if(this.search != ''){
        filterData.search = this.search
      }
      if(this.transactionId != ''){
        filterData.transactionId = this.transactionId
      }
      if(this.code != ''){
        filterData.code = this.code
      }
      if(this.logsType != ''){
        filterData.type = this.logsType
      }
      if(this.endDate){
        filterData.toDate = this.endDate
      }
      if(this.startDate){
        filterData.fromDate = this.startDate
      }

      this.filteredData = filterData






    },
    clear(){
      this.startDate = null
      this.endDate = null
      this.search = ''
      this.transactionId = ''
      this.code = ''
      this.logsType = ''
      this.filteredData = {userId : this.$route.params.id}




    },
  },
  beforeRouteEnter(to, from, next) {



    next(vm => vm.previousRoute = from.name)
  }

}
</script>

